/**
 * Scroll-reveal animations – Intersection Observer
 * Auto-targets homepage sections and their children.
 * Works without modifying individual section Liquid files.
 */
(function () {
  'use strict';

  /* ── Only run on the homepage ── */
  if (!document.querySelector('body.template-index')) {
    if (!document.querySelector('.pnw-hero')) return;
  }

  /* ── Config: which selectors get which animation ── */
  var sections = [
    /* ─── Technology showcase ─── */
    { selector: '.tech-section__heading', animation: 'blur-in' },
    { parent: '.tech-cards__grid', children: '.tech-card', animation: 'fade-up', stagger: 150 },

    /* ─── Video pop-up ─── */
    { selector: '.video-popup-section .sub-title-wrapper', animation: 'fade-right' },
    { selector: '.video-popup-section .title-wrapper', animation: 'blur-in' },
    { selector: '.video-popup-section .text-wrapper', animation: 'fade-up' },
    { selector: '.video-popup-section .video-play-icon', animation: 'fade-up' },
    { selector: '.video-popup-section__content > .button', animation: 'fade-up' },

    /* ─── Featured collection ─── */
    { selector: '.collection__title', animation: 'fade-up' },
    { selector: '.collection__description', animation: 'fade-up' },
    { parent: '#featured-collection-block', children: '.grid__item', animation: 'fade-up', stagger: 100 },
    { selector: '.collection__view-all', animation: 'bounce-up' },

    /* ─── Paw trail road ─── */
    { selector: '.paw-road', animation: 'fade-up' },

    /* ─── Support block ─── */
    { selector: '.support-block .title', animation: 'flip-up' },
    { parent: '.support-block-list', children: '.support-block-list__item', animation: 'fade-up', stagger: 160 },

    /* ─── Why PNW section ─── */
    { selector: '.why-pnw__label', animation: 'fade-down' },
    { selector: '.why-pnw__heading', animation: 'blur-in' },
    { selector: '.why-pnw__description', animation: 'fade-up' },
    { parent: '.why-pnw__features', children: '.why-pnw__feature', animation: 'fade-left', stagger: 120 },
    { selector: '.why-pnw__tagline', animation: 'bounce-up' },

    /* ─── Product tab ─── */
    { selector: '.product-tab', animation: 'fade-up' },

    /* ─── Catalog ─── */
    { selector: '.pnw-catalog__title', animation: 'blur-in' },
    { selector: '.pnw-catalog__subtitle', animation: 'fade-up' },
    { parent: '.pnw-catalog__grid', children: '.pnw-catalog__item', animation: 'pop', stagger: 90 },

    /* ─── Craft showcase ─── */
    { selector: '.craft-showcase__heading', animation: 'flip-up' },
    { parent: '.craft-showcase__grid', children: '.craft-showcase__card', animation: 'zoom-rotate', stagger: 120 },

    /* ─── Testimonials ─── */
    { selector: '.testimonials-header__title', animation: 'blur-in' },
    { selector: '.testimonials-header__subtitle', animation: 'fade-up' },
    { selector: '.testimonials-carousel', animation: 'scale-up' },

    /* ─── Join the pack CTA (rich-text) ─── */
    { selector: '.rich-text__blocks h2', animation: 'blur-in' },
    { selector: '.rich-text__text', animation: 'fade-up' },
    { selector: '.rich-text__blocks .button', animation: 'bounce-up' }
  ];

  /* ── Helper: mark an element for reveal ── */
  function mark(el, animation, delay) {
    if (!el || el.hasAttribute('data-scroll-reveal')) return;
    el.setAttribute('data-scroll-reveal', animation);
    if (delay) el.style.transitionDelay = delay + 'ms';
  }

  /* ── Apply data attributes ── */
  sections.forEach(function (cfg) {
    if (cfg.parent && cfg.children) {
      var parents = document.querySelectorAll(cfg.parent);
      parents.forEach(function (p) {
        p.setAttribute('data-scroll-stagger', '');
        var kids = p.querySelectorAll(cfg.children);
        kids.forEach(function (kid, i) {
          mark(kid, cfg.animation, cfg.stagger ? cfg.stagger * i : 0);
        });
      });
    } else if (cfg.selector) {
      document.querySelectorAll(cfg.selector).forEach(function (el) {
        mark(el, cfg.animation, 0);
      });
    }
  });

  /* ── Add glow class to key headings ── */
  document.querySelectorAll(
    '.tech-section__heading, .why-pnw__heading, .testimonials-header__title, .craft-showcase__heading'
  ).forEach(function (el) {
    el.classList.add('scroll-glow');
  });

  /* ── Intersection Observer ── */
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
  );

  document.querySelectorAll('[data-scroll-reveal]').forEach(function (el) {
    observer.observe(el);
  });

  /* ── Lightweight parallax on scroll (non-hero elements) ── */
  var parallaxEls = document.querySelectorAll('.why-pnw__paw-watermark');
  if (parallaxEls.length) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var scrollY = window.pageYOffset;
          parallaxEls.forEach(function (el) {
            var rect = el.getBoundingClientRect();
            if (rect.bottom > 0 && rect.top < window.innerHeight) {
              var speed = 0.08;
              el.style.transform = 'translateY(' + (scrollY * speed) + 'px)';
            }
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }
})();
